import { useIntl } from 'react-intl'
import { loadRCCalendarLocale } from 'src/services'
import { useAsyncValue } from 'src/hooks'

/**
 * Load and return the locale data that match the current locale code
 */
export default function useRcCalendarLocale() {
  const intl = useIntl()
  const [locale] = useAsyncValue(() => loadRCCalendarLocale(intl.locale), [intl.locale])
  return locale
}
